import { render } from "./TeamRosters.vue?vue&type=template&id=2a0791fe&scoped=true"
import script from "./TeamRosters.vue?vue&type=script&scoped=true&lang=js"
export * from "./TeamRosters.vue?vue&type=script&scoped=true&lang=js"

import "./TeamRosters.vue?vue&type=style&index=0&id=2a0791fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0791fe"]])

export default __exports__